import 'objectFitPolyfill';
import 'focus-visible';

import './features/detect';
import './features/no-transition-on-resize';
import './features/inner-height-variable';

import './views/menu';
import './views/popup';

import './view-initalizer';
